import { render, staticRenderFns } from "./TicketDetailForPurchaseHistory.vue?vue&type=template&id=0f982011&scoped=true&"
import script from "./TicketDetailForPurchaseHistory.vue?vue&type=script&lang=js&"
export * from "./TicketDetailForPurchaseHistory.vue?vue&type=script&lang=js&"
import style0 from "./TicketDetailForPurchaseHistory.vue?vue&type=style&index=0&id=0f982011&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f982011",
  null
  
)

export default component.exports